/**
 * GeChiUI dependencies
 */
import deprecated from '@gechiui/deprecated';

export default function DropZoneProvider( { children } ) {
	deprecated( 'gc.components.DropZoneProvider', {
		hint:
			'gc.component.DropZone no longer needs a provider. gc.components.DropZoneProvider is safe to remove from your code.',
	} );
	return children;
}
